import * as React from "react";

import { NamespaceManager } from "NamespaceManager";

export const NamespaceContext: React.Context<NamespaceManager | undefined> = React.createContext<
  NamespaceManager | undefined
>(undefined);
